import { useQuery } from '@tanstack/react-query';

import { FleetService } from '../services';
import { useFleet } from '../hooks';

export const useBlockNames = () => {
  const fleet = useFleet();
  const queryKey = ['blockNames', fleet?.uuid];

  const queryFn = () => FleetService.getBlockNames(fleet?.uuid);

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!fleet?.uuid,
  });
};

export const useBlockNamesWithDirections = () => {
  const fleet = useFleet();
  const queryKey = ['blockNamesWithDirections', fleet?.uuid];

  const queryFn = () => FleetService.getBlockNames(fleet?.uuid, true);

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!fleet?.uuid,
  });
};
